var _path, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.758 21.5c0 11.161-9.267 20.258-20.758 20.258S1.242 32.66 1.242 21.5 10.51 1.242 22 1.242 42.758 10.34 42.758 21.5z",
    stroke: "#F72A4F",
    strokeWidth: 2.485
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 21.5,
    rx: 13,
    ry: 12.5,
    fill: "#F72A4F"
  })));
}

export default SvgRecord;